import {
  EmploymentType,
  SupportedCountryCode,
  SupportedCountryCodeForNewSignup,
} from './models/types'

export const GUARANTEED_EARNINGS_WRONG_ZIP_ERROR: string = 'wrong_zip_code'
export const NON_MARKET_ERROR = "DoorDash isn't in your area yet!"

export const CHECKR_APPLICANT_URL = 'https://applicant.checkr.com/'

export const CANADA_BACKGROUND_CHECK_URL =
  'https://checkr.com/apply/doordash/113f9fbf4be'

export const HELP_URL = 'https://help.doordash.com'
export const DASHER_STORE = 'https://doordashstore.com/'

export const CANADA_HELP_URL =
  'https://help.doordash.com/dashers/s/article/Canada-Dasher-Sign-Up'

export const DASHER_APP_URL = 'https://www.doordash.com/dasher/app/'
export const IOS_DASHER_APP_URL =
  'https://itunes.apple.com/us/app/doordash-dasher/id1451754591'
export const ANDROID_DASHER_APP_URL =
  'https://play.google.com/store/apps/details?id=com.doordash.driverapp'

export const IDV_CONTACT_SUPPORT_URL =
  'https://doordash.formstack.com/forms/idverification'
export const IDV_FAQ_URL =
  'https://help.doordash.com/dashers/s/article/Dasher-Identification-Verification-FAQ'

export const DASHER_APPLICANT_FAQ_URL =
  'https://help.doordash.com/dashers/s/dasher-support'

export const BACKGROUND_CHECK_HELP_URL =
  'https://help.doordash.com/dashers/s/article/USA-Background-Check-FAQ'

export const SSN_CHECK_HELP_URL =
  'https://doordash.formstack.com/forms/idverification'

export const DASHER_DIRECT_URL = 'https://dasher.doordash.com/dasherdirect'

export const DASHER_SIGN_UP_SUPPORT_URL = 'https://help.doordash.com/s/'

export const DOORDASH_AUSTRALIA_STORE_URL = 'https://doordashaustraliastore.com'

export enum BUTTON_STATES {
  Success = 'SUCCESS',
  Error = 'ERROR',
}

export const BASE_GROWTH_IMAGE_CDN = `https://img.cdn4dd.com/s/managed/dasher/growth`
export const FIRST_DASH_PATH = `/first-dash`

/** List of background check vendor providers */
export enum BgcVendor {
  NCC = 'NCC',
}

export enum CheckrStatusResults {
  Pending = 'pending',
  Clear = 'clear',
  Consider = 'consider',
  Suspended = 'suspended',
  Skipped = 'skipped',
  Dispute = 'dispute',
  PreAA = 'preAA',
  PostAA = 'postAA',
}

export enum BackgroundCheckActionTracking {
  Help = 'help',
  RequestReview = 'request_review',
}

export const STATES = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District Of Columbia',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
}

export const CANADA_PROVINCES = {
  NL: 'Newfoundland and Labrador',
  PE: 'Prince Edward Island',
  NS: 'Nova Scotia',
  NB: 'New Brunswick',
  QC: 'Quebec',
  ON: 'Ontario',
  MB: 'Manitoba',
  SK: 'Saskatchewan',
  AB: 'Alberta',
  BC: 'British Columbia',
  YT: 'Yukon',
  NT: 'Northwest Territories',
  NU: 'Nunavut',
}

export const STATE_CODES = [
  ...Object.keys(STATES).map(key => ({
    name: key,
    value: key,
  })),
]
export const STATES_NAME = [
  ...Object.keys(STATES).map(key => ({
    name: STATES[key],
    value: key,
  })),
]

export const CANADA_PROVINCE_CODES = [
  ...Object.keys(CANADA_PROVINCES).map(key => ({
    name: key,
    value: key,
  })),
]

export const SupplyAcquisitionMethods = {
  DROPSHIPPING: 'DROPSHIPPING',
  GO_INTO_OFFICE: 'GO_INTO_OFFICE',
}

// TODO(swat-team): This is a hack so that Australian dashers can sign up.
// We will remove it once we implement international phone numbers.
export const AU_COUNTRY_CODE = '+61'

export const BASE_JOBS_URL = `https://doordash.com/dasher/driving-opportunities`
export const BASE_PATH = `/dasher/driving-opportunities`

export const AWS_BASE = `https://cdn.doordash.com`
export const CLOUDFLARE_BASE = `https://img.cdn4dd.com/cdn-cgi/image`
export const CLOUDFLARE_MANAGED_BASE = `https://img.cdn4dd.com/s/managed`
export const CLOUDFLARE_RESPONSIVE_BASE = `https://img.cdn4dd.com/p`
export const CLOUDFLARE_DEFAULT_PARAMS = `fit=contain,format=auto,quality=75`
export const CLOUDFLARE_DEFAULT_BASE = `${CLOUDFLARE_BASE}/${CLOUDFLARE_DEFAULT_PARAMS}`

export const JOB_1 = `Part-time driver`
export const JOB_2 = `Delivery driver`
export const JOB_3 = `Food delivery driver`
export const JOB_4 = `Food courier`
export const JOB_SUFFIX = `opportunity`

export const JOB_TYPE_1 = `part-time-driver`
export const JOB_TYPE_2 = `delivery-driver`
export const JOB_TYPE_3 = `food-delivery-driver`
export const JOB_TYPE_4 = `food-courier`

export const JOBS = [JOB_1, JOB_2, JOB_3, JOB_4]
export const JOB_TYPES = [JOB_TYPE_1, JOB_TYPE_2, JOB_TYPE_3, JOB_TYPE_4]

export enum CheckrStatus {
  WAITING = 'WAITING',
  DELAYED = 'DELAYED',
  NEEDS_ATTENTION = 'NEEDS_ATTENTION',
  CLEAR = 'CLEAR',
}

export const REDCARD_POLL_INTERVAL = 750 // second (750 ms)
export const TIMEOUT_TRIES = 5 // seconds

export const IOS_REDCARD_DEEPLINK = `comdoordashdriver://onboarding/completed`
export const ANDROID_REDCARD_DEEPLINK = `dddriver://onboarding/completed`
export const IOS_CLOSE_DEEPLINK = `comdoordashdriver://onboarding/completed`

// TODO: Replace this deeplink when we have a proper close deeplink
// Using the current completed deeplink affects Android analytics
export const ANDROID_CLOSE_DEEPLINK = `dddriver://onboarding/completed`

export enum ConfirmationStepTrackingKeys {
  BACKGROUNDCHECK = 'background_check',
  ABN = 'australian_business_number',
  ACTIVATIONKIT = 'activation_kit',
  REDCARDACTIVATION = 'red_card_activation',
  STARTDASHING = 'start_dashing',
  PAYMENTACCOUNTSETUP = 'add_bank_account',
  FASTPAY = 'fast_pay_setup',
  SAFETYCOURSE = 'safety_course',
  SSNCHECK = 'ssn_check',
}

export enum ConfirmationStepKeys {
  BACKGROUNDCHECK = 'backgroundCheckComplete',
  ABN = 'abnComplete',
  ACTIVATIONKIT = 'activationKit',
  PAYMENTACCOUNTSETUP = 'paymentAccountSetupComplete',
  REDCARDACTIVATION = 'redCardActivationComplete',
  STARTDASHING = 'hasCompletedFirstDelivery',
  FASTPAY = 'fastPaySetupComplete',
  HASCOMPLETEDSAFETYCOURSE = 'hasCompletedSafetyCourse',
  ISDASHERINSAFETYCOURSE = 'isDasherInDxSafetyCourse',
  ISDASHERINSAFETYCOURSESLIDE = 'isDasherInDxSafetyCourseSlides',
  SSNCHECK = 'ssn_check',
}

/**
 * IMPROVE @peterj35-dd: after upgrading to a version >=3.4 of typescript,
 * utilize `as const` operator to do the exact same thing but with no duplication
 */
export const COUNTRY_SHORTCODES: Record<
  SupportedCountryCode,
  SupportedCountryCode
> = {
  US: 'US',
  CA: 'CA',
  AU: 'AU',
  JP: 'JP',
  DE: 'DE',
  PR: 'PR',
  NZ: 'NZ',
}

export const COUNTRY_SHORTCODES_V2: Record<
  SupportedCountryCodeForNewSignup,
  SupportedCountryCodeForNewSignup
> = {
  US: 'US',
  CA: 'CA',
  AU: 'AU',
  DE: 'DE',
  PR: 'PR',
  NZ: 'NZ',
}

export const PR_MARKET_ID = 187

export const RED_CARD = 'red-card'

export const IN_APP_EDUCATION_SUB = 'in-app-education'

export const INSTANT_DASH_SPLASH_SUB = 'instant-dash-splash'

export const ACTIVATION_KIT_SPLASH_SUB = 'activation-kit-splash'

export const DASHER_EDUCATION_COURSE_SUB = 'education-course'

export const FAST_PAY_SUB = 'fast-pay'

export const DD_READY_FIRST_DASH_TS = 'dd_ready_first_dash_ts'

export const SEVEN_DAYS = 7 * 24 * 60 * 60

export const DASHER_ACTIVATION_HELP =
  // tslint:disable-next-line:max-line-length
  'https://help.doordash.com/dashers/s/article/About-the-Dasher-Activation-Kit?#tracking'

export const IDENTIFY_TIMEOUT = 5000

export const UTM_SOURCE = 'UTM_SOURCE'

export const FIRST_DASH_VIDEO_URL =
  'https://cdn.doordash.com/media/dasher/first_dash.mp4'
export const FIRST_DASH_VIDEO_EN_TRACK_URL =
  'https://cdn.doordash.com/media/dasher/first_dash_en.vtt'

export enum VehicleType {
  Bicycle = 'bicycle',
  Scooter = 'scooter',
  Motorcycle = 'motorcycle',
  Car = 'car',
  Walking = 'walking',
  Other = 'other',
}

export const VehicleIdMapping = {
  1: 'car',
  2: 'scooter',
  3: 'bicycle',
  4: 'motorcycle',
  5: 'walking',
}

export const CAR_MODELS = {
  Acura: [
    'Cl',
    'Ilx',
    'Integra',
    'Legend',
    'Mdx',
    'Mdx Sport Hybrid',
    'Nsx',
    'Rdx',
    'Rl',
    'Rlx',
    'Rlx Sport Hybrid',
    'Rsx',
    'Slx',
    'Tl',
    'Tlx',
    'Tsx',
    'Vigor',
    'Zdx',
  ],
  'Alfa Romeo': ['164', '4c', '4c Spider', 'Guilia', 'Spider', 'Stelvio'],
  'Aston Martin': [
    'Db11',
    'Db9',
    'Db9 Gt',
    'Dbs',
    'Dbs Superleggera',
    'Rapide',
    'Rapide S',
    'Vanquish',
    'Vanquish S',
    'Vantage',
    'Virage',
  ],
  Audi: [
    '100',
    '80',
    '90 (Hybrid)',
    'A3',
    'A3 Sportback E-Tron',
    'A4',
    'A4 ',
    'A4 Allroad',
    'A5',
    'A5 Sport',
    'A6',
    'A6 Allroad',
    'A7',
    'A8',
    'Allroad',
    'Cabriolet',
    'E-Tron',
    'Q3',
    'Q5',
    'Q7',
    'Q8',
    'Quattro',
    'R8',
    'Rs 3',
    'Rs 4',
    'Rs 5',
    'Rs 6',
    'Rs 7',
    'S3',
    'S4',
    'S4 (2005.5)',
    'S5',
    'S6',
    'S7',
    'S8',
    'Sq5',
    'Tt',
    'A7 Tfsi E',
    'Q5 Tfsi E',
  ],
  Bentley: [
    'Arnage',
    'Azure',
    'Azure T',
    'Bentayga',
    'Brooklands',
    'Continental',
    'Flying Spur',
    'Mulsanne',
  ],
  Bmw: [
    '1 Series',
    '2 Series',
    '3 Series',
    '4 Series',
    '5 Series',
    '6 Series',
    '7 Series',
    '8 Series',
    'Alpina B7',
    'I3',
    'I8',
    'M',
    'M2',
    'M3',
    'M4',
    'M5',
    'M6',
    'X1',
    'X2',
    'X3',
    'X3 M',
    'X4',
    'X5',
    'X5 M',
    'X6',
    'X6 M',
    'X7',
    'Z3',
    'Z4',
    'Z4 M',
    'Z8',
    'I3 120',
  ],
  Buick: [
    'Cascada',
    'Century',
    'Enclave',
    'Encore',
    'Encore Gx',
    'Envision',
    'Lacrosse',
    'Lesabre',
    'Lucerne',
    'Park Avenue',
    'Rainier',
    'Regal',
    'Regal Sportback',
    'Regal Tourx',
    'Rendezvous',
    'Riviera',
    'Roadmaster',
    'Skylark',
    'Terraza',
    'Verano',
  ],
  Cadillac: [
    'Allante',
    'Ats',
    'Ats-V',
    'Brougham',
    'Catera',
    'Ct4',
    'Ct5',
    'Ct6',
    'Ct6-V',
    'Cts',
    'Cts-V',
    'Deville',
    'Dts',
    'Eldorado',
    'Elr',
    'Escalade',
    'Escalade Esv',
    'Escalade Ext',
    'Fleetwood',
    'Seville',
    'Sixty Special',
    'Srx',
    'Sts',
    'Xlr',
    'Xt4',
    'Xt5',
    'Xt6',
    'Xts',
  ],
  Chevrolet: [
    '1500 Extended Cab',
    '1500 Regular Cab',
    '2500 Crew Cab',
    '2500 Extended Cab',
    '2500 Regular Cab',
    '3500 Crew Cab',
    '3500 Extended Cab',
    '3500 Regular Cab',
    'Apv Cargo',
    'Astro Cargo',
    'Astro Passenger',
    'Avalanche',
    'Avalanche 1500',
    'Avalanche 2500',
    'Aveo',
    'Beretta',
    'Blazer',
    'Bolt Ev',
    'Camaro',
    'Caprice',
    'Caprice Classic',
    'Captiva Sport',
    'Cavalier',
    'City Express',
    'Classic',
    'Cobalt',
    'Colorado Crew Cab',
    'Colorado Extended Cab',
    'Colorado Regular Cab',
    'Corsica',
    'Corvette',
    'Cruze',
    'Cruze Limited',
    'Equinox',
    'Express 1500 Cargo',
    'Express 1500 Passenger',
    'Express 2500 Cargo',
    'Express 2500 Passenger',
    'Express 3500 Cargo',
    'Express 3500 Passenger',
    'G-Series 1500',
    'G-Series 2500',
    'G-Series 3500',
    'G-Series G10',
    'G-Series G20',
    'G-Series G30',
    'Hhr',
    'Impala',
    'Impala Limited',
    'Lumina',
    'Lumina Apv',
    'Lumina Cargo',
    'Lumina Passenger',
    'Malibu',
    'Malibu (Classic)',
    'Malibu Limited',
    'Metro',
    'Monte Carlo',
    'Prizm',
    'S10 Blazer',
    'S10 Crew Cab',
    'S10 Extended Cab',
    'S10 Regular Cab',
    'Silverado 1500 ',
    'Silverado 2500 ',
    'Silverado 3500',
    'Sonic',
    'Spark (Gas)',
    'Spark Ev (Electric) ',
    'Sportvan G10',
    'Sportvan G20',
    'Sportvan G30',
    'Ss',
    'Ssr',
    'Suburban',
    'Suburban 1500',
    'Suburban 2500',
    'Suburban 3500hd',
    'Tahoe',
    'Tahoe (New)',
    'Tracker',
    'Trailblazer',
    'Traverse',
    'Trax',
    'Uplander Cargo',
    'Uplander Passenger',
    'Venture Cargo',
    'Venture Passenger',
    'Volt',
  ],
  Chevy: [
    'Bolt Euv',
    'Bolt Ev',
    'Silverado Ev (Electric)',
    'Future Ev (Electric)',
  ],
  Chrysler: [
    '200',
    '300',
    '300m',
    'Aspen',
    'Cirrus',
    'Concorde',
    'Crossfire',
    'Fifth Ave',
    'Grand Voyager',
    'Imperial',
    'Lebaron',
    'Lhs',
    'New Yorker',
    'Pacifica (Gas)',
    'Prowler',
    'Pt Cruiser',
    'Sebring',
    'Town & Country',
    'Voyager',
    'Pacifica (Electric)',
    'Pacifica (Hybrid)',
  ],
  Daewoo: ['Lanos', 'Leganza', 'Nubira', 'Cielo', 'Damas Ii'],
  Daihatsu: ['Charade', 'Rocky'],
  Dodge: [
    'Avenger',
    'Caliber',
    'Caravan Cargo',
    'Caravan Passenger',
    'Challenger',
    'Charger',
    'Colt',
    'D150',
    'D250',
    'D350',
    'Dakota',
    'Dart',
    'Daytona',
    'Durango',
    'Dynasty',
    'Grand Caravan Cargo',
    'Grand Caravan Passenger',
    'Intrepid',
    'Journey',
    'Magnum',
    'Monaco',
    'Neon',
    'Nitro',
    'Ram 1500',
    'Ram 2500',
    'Ram 3500',
    'Ram 50',
    'Ram Van 1500',
    'Ram Van 2500',
    'Ram Van 3500',
    'Ram Van B150',
    'Ram Van B250',
    'Ram Van B350',
    'Ram Wagon 1500',
    'Ram Wagon 2500',
    'Ram Wagon 3500',
    'Ram Wagon B150',
    'Ram Wagon B250',
    'Ram Wagon B350',
    'Ramcharger',
    'Shadow',
    'Spirit',
    'Sprinter 2500 Cargo',
    'Sprinter 2500 Passenger',
    'Sprinter 3500 Cargo',
    'Stealth',
    'Stratus',
    'Viper',
  ],
  Eagle: ['Premier', 'Summit', 'Talon', 'Vision'],
  Ferrari: [
    '430 Scuderia',
    '458 Italia',
    '458 Speciale',
    '458 Spider',
    '488 Gtb',
    '488 Spider',
    '599 Gtb Fiorano',
    '599 Gto',
    '612 Scaglietti',
    '812 Superfast',
    'California',
    'F12berlinetta',
    'F430',
    'Ff',
    'Gtc4lusso',
  ],
  Fiat: [
    '124 Spider',
    '500',
    '500 Abarth',
    '500c',
    '500c Abarth',
    '500e',
    '500l',
    '500x',
  ],
  Ford: [
    'Aerostar Cargo',
    'Aerostar Passenger',
    'Aspire',
    'Bronco',
    'C-Max Energi',
    'C-Max Hybrid',
    'Club Wagon',
    'Contour',
    'Crown Victoria',
    'E-Transit (Electric)',
    'E150 Cargo',
    'E150 Passenger',
    'E150 Super Duty Cargo',
    'E150 Super Duty Passenger',
    'E250 Cargo',
    'E250 Super Duty Cargo',
    'E350 Super Duty Passenger',
    'Econoline E150 Cargo',
    'Econoline E150 Passenger',
    'Econoline E250 Cargo',
    'Econoline E350 Super Duty Cargo',
    'Econoline E350 Super Duty Passenger',
    'Ecosport',
    'Edge',
    'Escape (Gas)',
    'Escape (Hybrid)',
    'Escape Phev',
    'Escape Se Phev',
    'Escort',
    'Excursion',
    'Expedition El',
    'Expedition Max',
    'Expedition',
    'Explorer Sport Trac',
    'Explorer Sport',
    'Explorer',
    'F-150 Lightning (Electric)',
    'F150 (Heritage) Regular Cab',
    'F150 (Heritage) Super Cab',
    'F150 Regular Cab',
    'F150 Super Cab',
    'F150 Supercrew Cab',
    'F250 Crew Cab',
    'F250 Regular Cab',
    'F250 Super Cab',
    'F250 Super Duty Crew Cab',
    'F250 Super Duty Regular Cab',
    'F250 Super Duty Super Cab',
    'F350 Crew Cab',
    'F350 Regular Cab',
    'F350 Super Cab',
    'F350 Super Duty Crew Cab',
    'F350 Super Duty Regular Cab',
    'F350 Super Duty Super Cab',
    'F450 Super Duty Crew Cab',
    'F450 Super Duty Regular Cab',
    'Festiva',
    'Fiesta',
    'Five Hundred',
    'Flex',
    'Focus Electric',
    'Focus St',
    'Focus',
    'Freestar Cargo',
    'Freestar Passenger',
    'Freestyle',
    'Fusion (Gas)',
    'Fusion Energi (Electric)',
    'Fusion Plug-In Hybrid',
    'Gt (Gas)',
    'Maverick (Hybrid)',
    'Mustang Mach-E',
    'Mustang',
    'Probe',
    'Ranger Regular Cab',
    'Ranger Super Cab',
    'Ranger Supercab',
    'Ranger Supercrew',
    'Taurus X',
    'Taurus',
    'Tempo',
    'Thunderbird',
    'Transit 150 Van',
    'Transit 150 Wagon',
    'Transit 250 Cargo Van',
    'Transit 250 Van',
    'Transit 350 Hd Van',
    'Transit 350 Van',
    'Transit 350 Wagon',
    'Transit Connect Cargo Van',
    'Transit Connect Cargo',
    'Transit Connect Passenger Wagon',
    'Transit Connect Passenger',
    'Windstar Cargo',
    'Windstar Passenger',
    'Zx2',
  ],
  Freightliner: [
    'Sprinter 1500 Cargo',
    'Sprinter 1500 Passenger',
    'Sprinter 2500 Cargo',
    'Sprinter 2500 Crew',
    'Sprinter 2500 Passenger',
    'Sprinter 3500 Cargo',
    'Sprinter 3500 Crew',
    'Sprinter 3500 Xd Crew',
    'Sprinter 3500xd Cargo',
    'Sprinter 4500 Cargo',
    'Sprinter 4500 Crew',
    'Sprinter Worker Cargo',
    'Sprinter Worker Passenger',
  ],
  Genesis: ['G70', 'G80', 'G90', 'Gv80'],
  Geo: ['Metro', 'Prizm', 'Storm', 'Tracker'],
  Gmc: [
    '1500 Club Coupe',
    '1500 Regular Cab',
    '2500 Club Coupe',
    '2500 Crew Cab',
    '2500 Hd Club Coupe',
    '2500 Regular Cab',
    '3500 Club Coupe',
    '3500 Crew Cab',
    '3500 Regular Cab',
    'Acadia',
    'Acadia Limited',
    'Canyon Crew Cab',
    'Canyon Regular Cab',
    'Envoy',
    'Envoy Xl',
    'Envoy Xuv',
    'Jimmy',
    'Rally Wagon 1500',
    'Rally Wagon 2500',
    'Rally Wagon 3500',
    'Rally Wagon G2500',
    'Rally Wagon G3500',
    'Safari Cargo',
    'Safari Passenger',
    'Savana 1500 Cargo',
    'Savana 1500 Passenger',
    'Savana 2500 Cargo',
    'Savana 2500 Passenger',
    'Savana 3500 Cargo',
    'Savana 3500 Passenger',
    'Sierra 1500 (Gas)',
    'Sierra 2500 ',
    'Sierra 3500 ',
    'Sonoma Club Cab',
    'Sonoma Club Coupe Cab',
    'Sonoma Crew Cab',
    'Sonoma Extended Cab',
    'Sonoma Regular Cab',
    'Suburban 1500',
    'Suburban 2500',
    'Terrain',
    'Vandura 1500',
    'Vandura 2500',
    'Vandura 3500',
    'Vandura G1500',
    'Vandura G2500',
    'Vandura G3500',
    'Yukon',
    'Yukon Denali',
    'Yukon Xl',
    'Yukon Xl 1500',
    'Yukon Xl 2500',
    'Sierra 1500 (Electric)',
    'Sierra 2500 (Electric)',
    'Sierra Denali',
    'Sierra 1500 Hybrid',
    'Yukon Hybrid',
  ],
  Honda: [
    'Accord (Gas)',
    'Accord Crosstour',
    'Accord Hybrid',
    'Civic',
    'Civic Type R',
    'Clarity Electric',
    'Clarity Fuel Cell',
    'Clarity Plug-In Hybrid',
    'Cr-V (Gas)',
    'Cr-V Hybrid (Hybrid) ',
    'Cr-Z',
    'Crosstour',
    'Del Sol',
    'Element',
    'Fit',
    'Hr-V',
    'Insight',
    'Odyssey',
    'Passport',
    'Pilot',
    'Prelude',
    'Ridgeline',
    'S2000',
    'Insight (Electric)',
  ],
  Hummer: ['H1', 'H2', 'H3', 'H3t', 'Ev Pickup', 'Ev Suv'],
  Hyundai: [
    'Accent',
    'Azera',
    'Elantra (Gas)',
    'Elantra Gt (Gas)',
    'Entourage',
    'Equus',
    'Excel',
    'Genesis',
    'Genesis Coupe',
    'Ioniq Electric',
    'Ioniq Hybrid',
    'Ioniq Plug-In Hybrid',
    'Kona (Gas)',
    'Nexo',
    'Palisade',
    'Santa Fe (Gas)',
    'Santa Fe Sport (Gas)',
    'Santa Fe Xl (Gas)',
    'Scoupe',
    'Sonata',
    'Sonata Hybrid',
    'Sonata Plug-In Hybrid',
    'Tiburon',
    'Tucson (Gas)',
    'Veloster',
    'Venue',
    'Veracruz',
    'Xg300',
    'Xg350',
    'Elantra Gt (Hybrid) ',
    'Santa Fe Sport (Hybrid) ',
    'Santa Fe Xl (Hybrid) ',
    'Kona (Electric)',
    'Tuscon (Hybrid)',
    'Santa Fe (Hybrid)',
    'Elantra (Hybrid)',
    'Nexo',
  ],
  Infiniti: [
    'Ex',
    'Fx',
    'G',
    'I',
    'J',
    'Jx',
    'M',
    'Q',
    'Q40',
    'Q50',
    'Q60',
    'Q70',
    'Qx',
    'Qx30',
    'Qx50',
    'Qx60',
    'Qx70',
    'Qx80',
  ],
  Isuzu: [
    'Amigo',
    'Ascender',
    'Axiom',
    'Hombre Regular Cab',
    'Hombre Spacecab',
    'I-280 Extended Cab',
    'I-290 Extended Cab',
    'I-350 Crew Cab',
    'I-370 Crew Cab',
    'I-370 Extended Cab',
    'Impulse',
    'Oasis',
    'Regular Cab',
    'Rodeo',
    'Rodeo Sport',
    'Spacecab',
    'Stylus',
    'Trooper',
    'Vehicross',
  ],
  Jaguar: [
    'E-Pace (Gas)',
    'F-Pace (Gas)',
    'F-Type',
    'I-Pace (Gas)',
    'S-Type',
    'X-Type',
    'Xe',
    'Xf',
    'Xj',
    'Xk',
    'E-Pace (Hybrid)',
    'F-Pace (Hybrid)',
    'I-Pace (Electric)',
  ],
  Jeep: [
    'Cherokee (Gas)',
    'Comanche Regular Cab',
    'Commander',
    'Compass',
    'Gladiator',
    'Grand Cherokee (Gas)',
    'Liberty',
    'Patriot',
    'Renegade',
    'Wrangler (Gas)',
    'Grand Cherokee 4xe (Electric)',
    'Wrangler 4xe (Electric)',
  ],
  Kia: [
    'Amanti',
    'Borrego',
    'Cadenza',
    'Ev6',
    'Forte Koup',
    'Forte',
    'Forte5',
    'K900',
    'Niro Ev',
    'Niro Plug-In Hybrid',
    'Niro',
    'Optima (Gas)',
    'Optima Hybrid',
    'Optima Plug-In Hybrid',
    'Rio',
    'Rondo',
    'Sedona (Gas)',
    'Sedona (Hybrid)',
    'Seltos',
    'Sephia',
    'Sorento (Gas)',
    'Sorento Hybrid',
    'Soul Ev',
    'Soul',
    'Spectra',
    'Sportage (Gas)',
    'Sportage Hybrid',
    'Stinger',
    'Telluride',
  ],
  Lamborghini: [
    'Aventador',
    'Gallardo',
    'Huracan',
    'Murcielago',
    'Murcielago Lp640',
    'Urus',
  ],
  'Land Rover': [
    '190 E',
    'Defender 110',
    'Defender 90',
    'Discovery',
    'Discovery Series Ii',
    'Discovery Sport',
    'Freelander',
    'Lr2',
    'Lr3',
    'Lr4',
    'Range Rover',
    'Range Rover Evoque',
    'Range Rover Sport',
    'Range Rover Velar',
    'Range Rover P400e',
  ],
  Lexus: [
    'Ct',
    'Es (Gas)',
    'Es Hybrid',
    'Gs',
    'Gx',
    'Hs',
    'Is F',
    'Is',
    'Lc (Gas)',
    'Lc Hybrid',
    'Lfa',
    'Ls (Gas)',
    'Ls Hybrid',
    'Lx',
    'Nx (Gas)',
    'Nx Hybrid',
    'Rc',
    'Rx (Gas)',
    'Rx Hybrd',
    'Sc',
    'Ux (Gas)',
    'Ux Hybrid',
  ],
  Lincoln: [
    'Aviator (Gas)',
    'Aviator (Hybrid)',
    'Blackwood',
    'Continental',
    'Corsair (Gas)',
    'Corsair (Hybrid)',
    'Ls (Electric)',
    'Mark Lt',
    'Mark Vii',
    'Mark Viii',
    'Mkc',
    'Mks',
    'Mkt',
    'Mkx',
    'Mkz',
    'Nautilus',
    'Navigator L',
    'Navigator',
    'Town Car',
    'Zephyr',
  ],
  Lotus: ['Elise', 'Evora', 'Evora 400', 'Exige', 'Exige S'],
  Lucid: ['Air'],
  Maserati: [
    'Coupe',
    'Ghibli',
    'Gransport',
    'Granturismo',
    'Levante',
    'Quattroporte',
    'Spyder',
  ],
  Mazda: [
    '323',
    '626',
    '929',
    'B-Series Cab Plus',
    'B-Series Extended Cab',
    'B-Series Regular Cab',
    'Cx-3',
    'Cx-30',
    'Cx-5',
    'Cx-7',
    'Cx-9',
    'Mazda2',
    'Mazda3 (Hybrid)',
    'Mazda5',
    'Mazda6',
    'Millenia',
    'Mpv',
    'Mx-3',
    'Mx-30',
    'Mx-5 Miata Rf',
    'Mx-5 Miata',
    'Mx-6',
    'Navajo',
    'Protege',
    'Protege5',
    'Rx-7',
    'Rx-8',
    'Tribute',
  ],
  Mclaren: ['570gt', '570s', '720s'],
  'Mercedes-Benz': [
    '300 Ce',
    '300 D',
    '300 E',
    '300 Sd',
    '300 Se',
    '300 Sl',
    '300 Te',
    '400 E',
    '400 Se',
    '400 Sel',
    '500 E',
    '500 Sec',
    '500 Sel',
    '500 Sl',
    '600 Sec',
    '600 Sel',
    '600 Sl',
    'A-Class',
    'B-Class',
    'C-Class',
    'Cl-Class',
    'Cla-Class',
    'Cla',
    'Clk-Class',
    'Cls-Class',
    'Cls',
    'E-Class',
    'Eqb',
    'Eqe',
    'Eqs',
    'Esprinter',
    'G-Class',
    'Gl-Class',
    'Gla-Class',
    'Gla',
    'Glb',
    'Glc 350e 4matic',
    'Glc Coupe',
    'Glc',
    'Gle Coupe',
    'Gle',
    'Glk-Class',
    'Gls',
    'M-Class',
    'Mercedes-Amg A-Class',
    'Mercedes-Amg C-Class',
    'Mercedes-Amg Cla',
    'Mercedes-Amg Cls',
    'Mercedes-Amg E-Class',
    'Mercedes-Amg G-Class',
    'Mercedes-Amg Gla',
    'Mercedes-Amg Glc (Gas)',
    'Mercedes-Amg Glc (Hybrid)',
    'Mercedes-Amg Glc',
    'Mercedes-Amg Gle (Gas)',
    'Mercedes-Amg Gle (Hybrid)',
    'Mercedes-Amg Gle Coupe',
    'Mercedes-Amg Gls (Gas)',
    'Mercedes-Amg Gls (Hybrid)',
    'Mercedes-Amg Gt',
    'Mercedes-Amg S-Class',
    'Mercedes-Amg Sl',
    'Mercedes-Amg Slc',
    'Mercedes-Amg Slk',
    'Mercedes-Maybach S 600',
    'Mercedes-Maybach S-Class',
    'Metris Cargo',
    'Metris Passenger',
    'Metris Worker Cargo',
    'Metris Worker Passenger',
    'R-Class',
    'S-Class',
    'Sl-Class',
    'Sl',
    'Slc',
    'Slk-Class',
    'Slk',
    'Slr Mclaren',
    'Sls-Class',
    'Sprinter 1500 Cargo (Gas)',
    'Sprinter 1500 Cargo (Hybrid)',
    'Sprinter 1500 Passenger',
    'Sprinter 2500 Cargo',
    'Sprinter 2500 Crew',
    'Sprinter 2500 Passenger',
    'Sprinter 3500 Cargo',
    'Sprinter 3500 Crew',
    'Sprinter 3500 Xd Cargo',
    'Sprinter 3500 Xd Crew',
    'Sprinter 4500 Cargo',
    'Sprinter 4500 Crew',
    'Sprinter Worker Cargo',
    'Sprinter Worker Passenger',
  ],
  Mercury: [
    'Capri',
    'Cougar',
    'Grand Marquis',
    'Marauder',
    'Mariner',
    'Milan',
    'Montego',
    'Monterey',
    'Mountaineer',
    'Mystique',
    'Sable',
    'Topaz',
    'Tracer',
    'Villager',
  ],
  Mini: [
    'Clubman',
    'Convertible',
    'Cooper (Gas)',
    'Countryman (Gas)',
    'Coupe',
    'Hardtop',
    'Hardtop 2 Door',
    'Hardtop 4 Door',
    'Paceman',
    'Roadster',
    'Cooper Se',
    'Countryman Hybrid',
  ],
  Mitsubishi: [
    '3000gt',
    'Diamante',
    'Eclipse',
    'Eclipse Cross',
    'Endeavor',
    'Expo',
    'Galant',
    'I-Miev',
    'Lancer',
    'Lancer Evolution',
    'Mighty Max Macro Cab',
    'Mighty Max Regular Cab',
    'Mirage G4',
    'Mirage',
    'Montero Sport',
    'Montero',
    'Outlander Phev',
    'Outlander Sport',
    'Outlander',
    'Precis',
    'Raider Double Cab',
    'Raider Extended Cab',
  ],
  Nissan: [
    '200sx',
    '240sx',
    '300zx',
    '350z',
    '370z',
    'Altima',
    'Armada',
    'Cube',
    'Frontier ',
    'Gt-R',
    'Juke',
    'Kicks',
    'King Cab',
    'Leaf',
    'Maxima',
    'Murano',
    'Nv1500 Cargo',
    'Nv200',
    'Nv200 Taxi',
    'Nv2500 Hd Cargo',
    'Nv3500 Hd Cargo',
    'Nv3500 Hd Passenger',
    'Nx',
    'Pathfinder',
    'Pathfinder Armada',
    'Quest',
    'Regular Cab',
    'Rogue',
    'Rogue Select',
    'Rogue Sport',
    'Sentra',
    'Stanza',
    'Titan Crew Cab',
    'Titan King Cab',
    'Titan Single Cab',
    'Titan Xd Crew Cab',
    'Titan Xd King Cab',
    'Titan Xd Single Cab',
    'Versa',
    'Versa Note',
    'Xterra',
  ],
  Oldsmobile: [
    '88',
    '98',
    'Achieva',
    'Alero',
    'Aurora',
    'Bravada',
    'Ciera',
    'Custom Cruiser',
    'Cutlass',
    'Cutlass Ciera',
    'Cutlass Cruiser',
    'Cutlass Supreme',
    'Intrigue',
    'Lss',
    'Regency',
    'Silhouette',
    'Toronado',
  ],
  'Peugot ': ['Ion'],
  Plymouth: [
    'Acclaim',
    'Breeze',
    'Colt',
    'Colt Vista',
    'Grand Voyager',
    'Laser',
    'Neon',
    'Prowler',
    'Sundance',
    'Voyager',
  ],
  Polestar: ['1', '2'],
  Pontiac: [
    'Aztek',
    'Bonneville',
    'Firebird',
    'G3',
    'G5',
    'G6',
    'G6 (2009.5)',
    'G8',
    'Grand Am',
    'Grand Prix',
    'Gto',
    'Lemans',
    'Montana',
    'Montana Sv6',
    'Solstice',
    'Sunbird',
    'Sunfire',
    'Torrent',
    'Trans Sport',
    'Vibe',
  ],
  Porsche: [
    '718 Boxster',
    '718 Cayman',
    '911',
    '928',
    '968',
    'Boxster',
    'Carrera Gt',
    'Cayenne (Gas)',
    'Cayenne Coupe (Gas)',
    'Cayman',
    'Macan',
    'Panamera (Gas)',
    'Panamera (Hybrid)',
    'Taycan',
    'Cayenne Turbo S E-Hybrid',
    'Cayenne E-Hybrid',
  ],
  Ram: [
    '1500 Crew Cab',
    '1500 Regular Cab',
    '2500 Regular Cab',
    '3500 Regular Cab',
    'C/V',
    'C/V Tradesman',
    'Dakota Crew Cab',
    'Dakota Extended Cab',
    'Promaster 1500 Cargo',
    'Promaster 2500 Cargo',
    'Promaster 3500 Cargo',
    'Promaster Cargo Van',
    'Promaster City',
    'Promaster Window Van',
  ],
  Rivian: ['R1s', 'R1t'],
  'Rolls-Royce': ['Cullinan', 'Dawn', 'Ghost', 'Phantom', 'Wraith'],
  Saab: ['9-2x', '9-3', '9-4x', '9-5', '9-7x', '900', '9000'],
  Saturn: [
    'Astra',
    'Aura',
    'Ion',
    'L-Series',
    'Outlook',
    'Relay',
    'S-Series',
    'Sky',
    'Vue (Hybrid)',
  ],
  Scion: ['Fr-S', 'Ia', 'Im', 'Iq', 'Tc', 'Xa', 'Xb', 'Xd'],
  Smart: [
    'Fortwo',
    'Fortwo Cabrio',
    'Fortwo Electric Drive',
    'Fortwo Electric Drive Cabrio',
    'Fortwo Eq Cabrio',
    'Fortwo Eq Coupe',
  ],
  Subaru: [
    'Ascent',
    'B9 Tribeca',
    'Baja',
    'Brz',
    'Crosstrek (Gas)',
    'Crosstrek Hybrid',
    'Forester',
    'Impreza',
    'Justy',
    'Legacy',
    'Loyale',
    'Outback',
    'Svx',
    'Tribeca',
    'Wrx',
    'Xv Crosstrek',
  ],
  Suzuki: [
    'Aerio',
    'Equator Crew Cab',
    'Equator Extended Cab',
    'Esteem',
    'Forenza',
    'Grand Vitara',
    'Kizashi',
    'Reno',
    'Samurai',
    'Sidekick',
    'Swift',
    'Sx4',
    'Verona',
    'Vitara',
    'X-90',
    'Xl-7',
    'Xl7',
  ],
  Tesla: ['Model 3', 'Model S', 'Model X'],
  Toyota: [
    '4runner',
    '86',
    'Avalon (Gas)',
    'Avalon (Hybrid)',
    'Bz4x',
    'C-Hr',
    'Camry (Gas)',
    'Camry(Hybrid)',
    'Celica',
    'Corolla (Gas)',
    'Corolla (Hybrid)',
    'Corolla Im',
    'Cressida',
    'Echo',
    'Fj Cruiser',
    'Gr Supra',
    'Highlander (Gas)',
    'Highlander (Hybrid)',
    'Land Cruiser',
    'Matrix',
    'Mirai',
    'Mr2',
    'Paseo',
    'Previa',
    'Prius C',
    'Prius Plug-In Hybrid',
    'Prius Prime (Electric)',
    'Prius Prime',
    'Prius V',
    'Prius',
    'Rav4 (Gas)',
    'Rav4 (Hybrid)',
    'Rav4 Prime (Electric)',
    'Sequoia',
    'Sienna (Gas)',
    'Sienna Hybrid',
    'Solara',
    'Supra',
    'T100 Regular Cab',
    'T100 Xtracab',
    'Tacoma',
    'Tercel',
    'Tundra ',
    'Tundra Hybrid',
    'Venza (Gas)',
    'Venza Hybrid',
    'Xtra Cab',
    'Yaris (Gas)',
    'Yaris (Hybrid)',
    'Yaris Hatchback (Gas)',
    'Yaris Hatchback (Hybrid)',
    'Yaris Ia (Gas)',
    'Yaris Ia (Hybrid)',
  ],
  Volkswagen: [
    'Arteon',
    'Atlas Cross Sport',
    'Atlas',
    'Beetle',
    'Cabrio',
    'Cabriolet',
    'Cc',
    'Corrado',
    'E-Golf Se',
    'E-Golf',
    'Eos',
    'Eurovan',
    'Fox',
    'Gli',
    'Golf Alltrack',
    'Golf Gti',
    'Golf Iii',
    'Golf R',
    'Golf Sportwagen',
    'Golf',
    'Gti',
    'Id.4',
    'Id',
    'Jetta Gli',
    'Jetta Hybrid',
    'Jetta Iii',
    'Jetta Sportwagen',
    'Jetta',
    'New Beetle',
    'Passat',
    'Phaeton',
    'R32',
    'Rabbit',
    'Routan',
    'Tiguan Limited',
    'Tiguan',
    'Touareg (Gas)',
    'Touareg R (Hybrid)',
  ],
  Volvo: [
    '240',
    '740',
    '850',
    '940',
    '960',
    'C30',
    'C70',
    'S40',
    'S60 (Gas)',
    'S70',
    'S80',
    'S90 (Gas)',
    'V40',
    'V50',
    'V60 (Gas)',
    'V70',
    'V90',
    'Xc40 (Hybrid)',
    'Xc60',
    'Xc70',
    'Xc90 (Gas)',
    'Xc40 Recharge (Electric)',
    'C40 Recharge (Electric)',
    'S60 Recharge',
    'S90 Recharge',
    'V60 Recharge',
    'Xc40 Recharge Pure Electric',
    'Xc60 Recharge',
    'Xc90 Recharge',
  ],
  Xfiniti: ['Q50'],
}

export const CAR_MAKES = Object.keys(CAR_MODELS).sort()

export const CAR_COLORS = [
  'silver',
  'white',
  'black',
  'blue',
  'gray',
  'red',
  'green',
  'brown',
  'gold',
  'tan',
  'orange',
  'yellow',
  'purple',
]

// For in-app web signup
export const IOS_SIGNUP_SOURCE_PARAM = 'dx_app_iOS'

export const API_PROXY = 'api-public-dasher'

export const UNIQUE_LINK_KEY = 'applicant_unique_link'

export const EMAIL_KEY = 'applicant_email'

interface OnboardingConfig {
  [onboardingStep: string]: {
    [featureConfig: string]: {
      [countryShortName: string]: boolean | string | number | EmploymentType // Since both `unknown` and `any` are not usable, will be using union types for now
    }
  }
}

export const ONBOARDING_CONFIGURATIONS: OnboardingConfig = {
  signupPage: {
    employmentType: {
      DE: 'W2',
      default: 'INDIVIDUAL_CONTRACTOR',
    },
  },
  profileSetup: {
    subHeaderUseNewInstructions: {
      DE: false,
      default: true,
    },
    hideReferralOption: {
      DE: true,
      JP: true,
      default: false,
    },
  },
  backgroundCheck: {
    required: {
      DE: false,
      default: true,
    },
  },
  vehicleDetails: {
    showThisStep: {
      DE: true,
      default: false,
    },
    requireAdditionalCarInfo: {
      US: true,
      default: false,
    },
  },
  signUpCompletion: {
    showThisStep: {
      DE: true,
      default: false,
    },
  },
  orientation: {
    showThisStep: {
      AU: true,
      JP: true,
      default: false,
    },
  },
  progressionCheck: {
    showThisStep: {
      JP: true,
      default: false,
    },
  },
  phoneVerification: {
    checkSupplementalOnboardingUserExperience: {
      JP: false,
      DE: false,
      default: true,
    },
  },
}

export const idvStep = {
  Start: 'start',
  Complete: 'complete',
  Fail: 'fail',
}

export type PersonaEvent =
  | 'load'
  | 'start'
  | 'country-select'
  | 'document-camera-select'
  | 'document-camera-capture'
  | 'document-upload'
  | 'verification-select'
  | 'verification-change'
  | 'success'
  | 'fail'
  | 'exit'
  | 'selfie-camera-select'
  | 'selfie-camera-capture'

export enum CitizenshipStatus {
  OTHERS = 'OTHERS',
  SPECIAL_PERMANENT_RESIDENT = 'SPECIAL_PERMANENT_RESIDENT',
  CITIZEN = 'CITIZEN',
}

export enum PERSONA_ENV {
  Production = 'production',
  Sandbox = 'sandbox',
}

// One year in seconds
export const COOKIE_AGE_ONE_YEAR = 365 * 24 * 60 * 60

/**
 * The error msgs are to handle invalid and R2A email and phone formats
 * Ideally this will be sent by the API
 */
export const returnToApplicationEmailErrorMessages = new Set([
  'There is already an account with that email address.',
  'Es gibt bereits ein Konto mit dieser E-Mail-Adresse.',
  'そのメールアドレスではすでにアカウントが存在します。',
  'Ya hay una cuenta con esa dirección de correo electrónico.',
  'Un compte est déjà associé à cette adresse courriel.',
  'Email address provided does not seem to be a valid one',
  "L'adresse courriel fournie ne semble pas être valide",
  'La dirección de correo electrónico proporcionada no parece ser válida',
  '入力されたメールアドレスが有効ではないようです',
  'Die angegebene E-Mail-Adresse scheint ungültig zu sein.',
])

export const returnToApplicationPhoneErrorMessages = new Set([
  'There is already an account with that phone number.',
  'Es gibt bereits ein Konto mit dieser Telefonnummer.',
  'その電話番号ではすでにアカウントが存在します。',
  'Ya hay una cuenta con ese número de teléfono.',
  'Un compte est déjà associé à ce numéro de téléphone.',
])

export const returnToApplicationZipcodeErrorMessages = new Set([
  'Zipcode provided does not seem to be a valid one',
  'Le code postal fourni n\u0027est pas valide.',
  'La dirección de correo electrónico proporcionada no parece ser válida',
  '入力されたメールアドレスが有効ではないようです',
  'Die angegebene PLZ ist ungültig.',
  'Postal code provided does not seem to be a valid one',
])
